import { Fetcher } from "../helpers/fetcher";

export const BucketNames = ["bnkle-iam-docs"];

let Base_URL = process.env.REACT_APP_IAM_URL;
export const GetUploadSignedUrls = (
  contentType: string,
  bucketName?: string
) => {
  const payload = {
    Extension: contentType.split("/")[1],
    Bucket: bucketName || BucketNames[0],
    ContentType: contentType,
    uploadArea: "landingpage",
  };
  return Fetcher(`${Base_URL}/files/upload`, "POST", payload);
};
